import { CrownIcon, ShareIcon } from '../../../assets/icons';
import Card from '../../../components/Card';
import useModalState from '../../../context/modal/useModalState';
import { formatPercentages, formatUSD } from '../../../helpers';
import { LeaderboardDto } from '../../../context/leaderboard/leaderboardTypes';
import { parseEther } from 'ethers/lib/utils';
import { ShareModalType } from '../../../modals/Share/ShareModal';
import UserReferral from '../../../components/UserReferral';

type LeaderboardPnlRowProps = {
    data: LeaderboardDto & { rank: number };
    isUserRanking?: boolean; // Is it the row showed under "My Ranking" ?
    style?: React.CSSProperties;
};

const LeaderboardPnlRow: React.FC<LeaderboardPnlRowProps> = ({
    data,
    isUserRanking = false,
    style,
}) => {
    const { openModal, setModalData } = useModalState();
    const {
        rank,
        userId,
        totalMargin,
        realizedPnL,
        realizedPnLPercentage,
        wins,
        losses,
    } = data;

    const handleCardClick = () => {
        openModal('sharePnlRankingModal');
        setModalData((prev) => ({
            ...prev,
            data: {
                position: data,
                type: ShareModalType.PnL,
            },
        }));
    };

    const hasProfit = parseEther(realizedPnL || '0').gte(0);

    return (
        <Card
            onClick={isUserRanking ? handleCardClick : undefined}
            className='leaderboard-pnl__row row'
            style={style}
        >
            <div className={`leaderboard__rank rank-${rank + 1}`}>
                {rank + 1} {rank < 3 ? <CrownIcon /> : null}
            </div>
            <UserReferral userAddress={userId} className='leaderboard__user' />
            <div className='leaderboard__trades-opened'>
                <span className='column-label'>Wins</span>
                {wins}
            </div>
            <div className='leaderboard__trades-settled'>
                <span className='column-label'>Losses</span>
                {losses}
            </div>
            <div className='leaderboard__collateral'>
                <span className='column-label'>Collateral</span>
                {formatUSD(totalMargin?.toString() || 0, { minDecimals: 2 })}
            </div>
            <div
                className={`leaderboard__profit ${hasProfit ? 'increased' : 'decreased'}`}
            >
                <span className='column-label'>PnL</span>
                <div>
                    {formatUSD(realizedPnL || 0, { minDecimals: 2 })} (
                    {realizedPnL && +realizedPnL > 0 ? '+' : ''}
                    {formatPercentages(realizedPnLPercentage.toString())}
                    %)
                    {isUserRanking && <ShareIcon />}
                </div>
            </div>
        </Card>
    );
};

export default LeaderboardPnlRow;
